var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('ul',[_c('li',[_vm._v("token_version_id: "+_vm._s(_vm.$route.query.token_version_id))]),_c('li',[_vm._v("enc_data: "+_vm._s(_vm.$route.query.enc_data))]),_c('li',[_vm._v("integrityValue: "+_vm._s(_vm.$route.query.integrity_value))])])])
}
var staticRenderFns = []

export { render, staticRenderFns }